import { FC } from 'react';
import { useQuery } from '@tanstack/react-query';
import { useNavigate } from 'react-router-dom';
import { Dialog } from 'primereact/dialog';
import { formatDate } from '@/utils/formatDate';
import { TableData } from '@/components/Table/types';
import { Table, LoadingSpinner } from '@/components';
import { ColumnProps } from 'primereact/column';
import { useTranslation } from 'react-i18next';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faBook } from '@fortawesome/free-solid-svg-icons';
import { getScheduleImportFcl } from '../Depo20/services/getScheduleImportFcl';

const ScheduleDetail: FC = () => {
  const { t } = useTranslation('importFCL');
  const navigate = useNavigate();

  const { data = [], isFetching } = useQuery({
    queryKey: ['schedule'],
    queryFn: () => getScheduleImportFcl(),
  });

  const columns: ColumnProps[] = [
    {
      field: 'fecha',
      header: t('scheduleTable.date'),
      body: (rowData) => formatDate(rowData?.fecha),
    },
    {
      field: 'disponibles',
      header: t('scheduleTable.availables'),
    },
  ];

  const dialogHeader = (
    <div className="text-blue-800">
      <FontAwesomeIcon icon={faBook} style={{ marginRight: '0.5rem' }} />
      {t('scheduleDetail')}
    </div>
  );

  return (
    <Dialog
      header={dialogHeader}
      visible
      style={{
        maxWidth: window.innerWidth <= 1200 ? '95vw' : '1200px',
        minWidth: window.innerWidth <= 1200 ? '95vw' : '1200px',
      }}
      onHide={() => navigate(-1)}
      modal
    >
      <div className="pb-4 px-4">
        <p>{t('scheduleAvailableMessage')}</p>
        <br />
        {isFetching ? (
          <LoadingSpinner />
        ) : (
          <Table columns={columns} data={data as unknown as TableData} />
        )}
      </div>
    </Dialog>
  );
};

export default ScheduleDetail;
